module.exports = __webpack_public_path__ + "img/side-icon-52-off.5d479a18.svg";